import { atomWithStorage } from 'jotai/utils';

export const releaseNotesSeenDateAtom = atomWithStorage('release_notes_seen_date', '');
